import {i18n} from "../../shared/i18n";
const STATUS = {
    draft: {
        get label() { return i18n.t("sections.onboarding.p160"); },
        tone: "neutral",
        get meaning() { return i18n.t("sections.onboarding.p219"); },
        actions: ["rotate_access_token"],
    },
    under_moderation: {
        get label() { return i18n.t("sections.onboarding.p161"); },
        tone: "warning",
        get meaning() { return i18n.t("sections.onboarding.p220"); },
        actions: ["request_documents", "reject", "publish"],
    },
    documents_required: {
        get label() { return i18n.t("sections.onboarding.p162"); },
        tone: "blue",
        get meaning() { return i18n.t("sections.onboarding.p221"); },
        actions: ["reject", "rotate_access_token"],
    },
    published: {
        get label() { return i18n.t("sections.onboarding.p163"); },
        tone: "success",
        get meaning() { return i18n.t("sections.onboarding.p222"); },
        actions: ["rotate_credentials"],
    },
    rejected: {
        get label() { return i18n.t("sections.onboarding.p164"); },
        tone: "danger",
        get meaning() { return i18n.t("sections.onboarding.p223"); },
        actions: [],
    },
    limited_financial_activation: {
        get label() { return i18n.t("sections.onboarding.p165"); },
        tone: "neutral",
        get meaning() { return i18n.t("sections.onboarding.p224"); },
        actions: [],
    },
    fully_verified: {
        get label() { return i18n.t("sections.onboarding.p166"); },
        tone: "neutral",
        get meaning() { return i18n.t("sections.onboarding.p224"); },
        actions: [],
    },
    activated: {
        get label() { return i18n.t("sections.onboarding.p167"); },
        tone: "neutral",
        get meaning() { return i18n.t("sections.onboarding.p224"); },
        actions: [],
    },
    disabled: {
        get label() { return i18n.t("sections.onboarding.p168"); },
        tone: "neutral",
        get meaning() { return i18n.t("sections.onboarding.p224"); },
        actions: [],
    },
};

const ACTION = {
    request_documents: {
        get label() { return i18n.t("sections.onboarding.p177"); },
        resultStatus: "documents_required",
        tone: "warning",
    },
    reject: {get label() { return i18n.t("sections.onboarding.p225"); }, resultStatus: "rejected", tone: "danger"},
    publish: {get label() { return i18n.t("sections.onboarding.p182"); }, resultStatus: "published", tone: "success"},
    rotate_access_token: {
        get label() { return i18n.t("sections.onboarding.p184"); },
        resultStatus: null,
        tone: "warning",
    },
    rotate_credentials: {
        get label() { return i18n.t("sections.onboarding.p186"); },
        resultStatus: null,
        tone: "warning",
    },
};

export const getStatusPresentation = (status) => {
    const presentation = STATUS[status];
    return presentation
        ? {...presentation, known: true}
        : {
              label: i18n.t("sections.onboarding.p226"),
              tone: "neutral",
              meaning: i18n.t("sections.onboarding.p227"),
              actions: [],
              known: false,
          };
};

export const getVisibleActions = (status, allowedActions) => {
    const presentation = STATUS[status];
    if (!presentation || !Array.isArray(allowedActions)) {
        return [];
    }
    return presentation.actions.filter((action) => allowedActions.includes(action));
};

export const getActionPresentation = (actionId) => ACTION[actionId] || null;

export const hasCompletePublishedGraph = (resources) =>
    [
        "created_user_id",
        "created_place_id",
        "created_branch_id",
        "created_company_id",
        "created_organization_branch_id",
        "created_staff_member_id",
    ].every((key) => Number.isInteger(resources?.[key]) && resources[key] > 0);
